export default __webpack_public_path__ + "static/media/404.ef5dc0f9.svg";